export enum LearningCategory {
	GETTING_STARTED = 'Getting Started',
	MECHANICAL_TESTING = 'Mechanical Testing',
	ELECTRICAL_TESTING = 'Electrical Testing',
	SAFETY_PROCEDURES = 'Safety & Procedures',
	TROUBLESHOOTING = 'Troubleshooting',
	MAINTENANCE = 'Maintenance & Care',
	TECHNICAL_SPECS = 'Technical Specifications',
	CERTIFICATIONS = 'Certifications & Standards',
	CASE_STUDIES = 'Case Studies'
}

export const LearningCategoryLabels: Record<LearningCategory, string> = {
	[LearningCategory.GETTING_STARTED]: 'Начало работы',
	[LearningCategory.MECHANICAL_TESTING]: 'Механические испытания',
	[LearningCategory.ELECTRICAL_TESTING]: 'Электрические испытания',
	[LearningCategory.SAFETY_PROCEDURES]: 'Безопасность и процедуры',
	[LearningCategory.TROUBLESHOOTING]: 'Устранение неполадок',
	[LearningCategory.MAINTENANCE]: 'Обслуживание и уход',
	[LearningCategory.TECHNICAL_SPECS]: 'Технические характеристики',
	[LearningCategory.CERTIFICATIONS]: 'Сертификаты и стандарты',
	[LearningCategory.CASE_STUDIES]: 'Кейсы и примеры использования'
}

export enum ResourceType {
	PDF = 'pdf',
	VIDEO = 'video',
	IMAGE = 'image',
	FILE = 'file',
	TEXT = 'text'
}

export interface LearningResource {
	id: string
	type: ResourceType
	title: string
	description?: string

	// File-based (PDF, IMAGE, FILE)
	signedUrl?: string
	fileUrl?: string
	fileName?: string
	fileSize?: number
	mimeType?: string

	// Video
	videoUrl?: string
	videoId?: string
	embedUrl?: string
	thumbnailUrl?: string
	duration?: number

	// Rich-text page (TEXT)
	content?: string

	order: number
	createdAt: string
	updatedAt: string
}

export interface LearningMaterial {
	id: string
	title: string
	description?: string
	category: LearningCategory
	subcategory?: string
	relayTypeId?: string
	relayTypeName?: string
	isPublished: boolean
	createdBy?: string
	creatorName?: string
	resources?: LearningResource[]
	pdfCount?: number
	videoCount?: number
	createdAt: string
	updatedAt: string
}

export interface MaterialsResponse {
	materials: LearningMaterial[]
	total: number
}

export interface CategoryStat {
	category: string
	count: number
}

export interface RelayTypeStat {
	relayTypeId: string
	relayTypeName: string
	count: number
}

export interface CreateResourcePayload {
	type: ResourceType
	title: string
	description?: string
	// File-based resources
	fileUrl?: string
	fileName?: string
	fileSize?: number
	mimeType?: string
	// Video
	videoUrl?: string
	duration?: number
	// Rich-text page
	content?: string
	order?: number
}

export interface CreateMaterialPayload {
	material: {
		title: string
		description?: string
		category: LearningCategory
		subcategory?: string
		relayTypeId?: string
		isPublished?: boolean
	}
	resources: CreateResourcePayload[]
}

export interface UpdateMaterialPayload {
	title?: string
	description?: string
	category?: LearningCategory
	subcategory?: string
	relayTypeId?: string
	isPublished?: boolean
}

export interface ViewLogResponse {
	success: boolean
	relatedMaterials: LearningMaterial[]
}

export interface LearningUploadResponse {
	fileUrl: string
	fileName: string
	fileSize: number
	mimeType: string
}
